'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MERGE_SYLLABUS_ERROR = exports.MERGE_SYLLABUS_SUCCESS = exports.MERGE_SYLLABUS_START = exports.SPLIT_SYLLABUS_ERROR = exports.SPLIT_SYLLABUS_SUCCESS = exports.SPLIT_SYLLABUS_START = exports.UPDATE_SYLLABUS_ERROR = exports.UPDATE_SYLLABUS_SUCCESS = exports.UPDATE_SYLLABUS_START = exports.REMOVE_SYLLABUS_ERROR = exports.REMOVE_SYLLABUS_SUCCESS = exports.REMOVE_SYLLABUS_START = exports.CREATE_SYLLABUS_ERROR = exports.CREATE_SYLLABUS_SUCCESS = exports.CREATE_SYLLABUS_START = exports.SEED_SYLLABUS_ERROR = exports.SEED_SYLLABUS_SUCCESS = exports.SEED_SYLLABUS_START = undefined;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _dispatcher = require('../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _actionFactory = require('../action-factory');

var _actionFactory2 = _interopRequireDefault(_actionFactory);

var _actions = require('../stages/actions');

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEED_SYLLABUS_START = exports.SEED_SYLLABUS_START = 'SEED_SYLLABUS_START';
var SEED_SYLLABUS_SUCCESS = exports.SEED_SYLLABUS_SUCCESS = 'SEED_SYLLABUS_SUCCESS';
var SEED_SYLLABUS_ERROR = exports.SEED_SYLLABUS_ERROR = 'SEED_SYLLABUS_ERROR';

var CREATE_SYLLABUS_START = exports.CREATE_SYLLABUS_START = 'CREATE_SYLLABUS_START';
var CREATE_SYLLABUS_SUCCESS = exports.CREATE_SYLLABUS_SUCCESS = 'CREATE_SYLLABUS_SUCCESS';
var CREATE_SYLLABUS_ERROR = exports.CREATE_SYLLABUS_ERROR = 'CREATE_SYLLABUS_ERROR';

var REMOVE_SYLLABUS_START = exports.REMOVE_SYLLABUS_START = 'REMOVE_SYLLABUS_START';
var REMOVE_SYLLABUS_SUCCESS = exports.REMOVE_SYLLABUS_SUCCESS = 'REMOVE_SYLLABUS_SUCCESS';
var REMOVE_SYLLABUS_ERROR = exports.REMOVE_SYLLABUS_ERROR = 'REMOVE_SYLLABUS_ERROR';

var UPDATE_SYLLABUS_START = exports.UPDATE_SYLLABUS_START = 'UPDATE_SYLLABUS_START';
var UPDATE_SYLLABUS_SUCCESS = exports.UPDATE_SYLLABUS_SUCCESS = 'UPDATE_SYLLABUS_SUCCESS';
var UPDATE_SYLLABUS_ERROR = exports.UPDATE_SYLLABUS_ERROR = 'UPDATE_SYLLABUS_ERROR';

var SPLIT_SYLLABUS_START = exports.SPLIT_SYLLABUS_START = 'SPLIT_SYLLABUS_START';
var SPLIT_SYLLABUS_SUCCESS = exports.SPLIT_SYLLABUS_SUCCESS = 'SPLIT_SYLLABUS_SUCCESS';
var SPLIT_SYLLABUS_ERROR = exports.SPLIT_SYLLABUS_ERROR = 'SPLIT_SYLLABUS_ERROR';

var MERGE_SYLLABUS_START = exports.MERGE_SYLLABUS_START = 'MERGE_SYLLABUS_START';
var MERGE_SYLLABUS_SUCCESS = exports.MERGE_SYLLABUS_SUCCESS = 'MERGE_SYLLABUS_SUCCESS';
var MERGE_SYLLABUS_ERROR = exports.MERGE_SYLLABUS_ERROR = 'MERGE_SYLLABUS_ERROR';

_angular2.default.module('ifeis.syllabi.actions', ['ifeis.dispatcher', 'ifeis.events', 'ifeis.syllabi.store']).factory('syllabusActions', function (dispatcher, fEventService, syllabusStore, stageActions) {
  var seedStart = (0, _actionFactory2.default)(dispatcher, SEED_SYLLABUS_START);
  var seedSuccess = (0, _actionFactory2.default)(dispatcher, SEED_SYLLABUS_SUCCESS);
  var seedError = (0, _actionFactory2.default)(dispatcher, SEED_SYLLABUS_ERROR);
  var createStart = (0, _actionFactory2.default)(dispatcher, CREATE_SYLLABUS_START);
  var createSuccess = (0, _actionFactory2.default)(dispatcher, CREATE_SYLLABUS_SUCCESS);
  var createError = (0, _actionFactory2.default)(dispatcher, CREATE_SYLLABUS_ERROR);
  var updateStart = (0, _actionFactory2.default)(dispatcher, UPDATE_SYLLABUS_START);
  var updateSuccess = (0, _actionFactory2.default)(dispatcher, UPDATE_SYLLABUS_SUCCESS);
  var updateError = (0, _actionFactory2.default)(dispatcher, UPDATE_SYLLABUS_ERROR);
  var removeStart = (0, _actionFactory2.default)(dispatcher, REMOVE_SYLLABUS_START);
  var removeSuccess = (0, _actionFactory2.default)(dispatcher, REMOVE_SYLLABUS_SUCCESS);
  var removeError = (0, _actionFactory2.default)(dispatcher, REMOVE_SYLLABUS_ERROR);
  var splitStart = (0, _actionFactory2.default)(dispatcher, SPLIT_SYLLABUS_START);
  var splitSuccess = (0, _actionFactory2.default)(dispatcher, SPLIT_SYLLABUS_SUCCESS);
  var splitError = (0, _actionFactory2.default)(dispatcher, SPLIT_SYLLABUS_ERROR);
  var mergeStart = (0, _actionFactory2.default)(dispatcher, MERGE_SYLLABUS_START);
  var mergeSuccess = (0, _actionFactory2.default)(dispatcher, MERGE_SYLLABUS_SUCCESS);
  var mergeError = (0, _actionFactory2.default)(dispatcher, MERGE_SYLLABUS_ERROR);

  function seed(feis, context) {
    seedStart({ feis: feis }, context);

    return fEventService.for(feis.id).all({ stats: true }).then(function (events) {
      return seedSuccess({ feis: feis, events: events }, context);
    }).catch(function (err) {
      return seedError(err, context);
    });
  }

  function create(event, context) {
    createStart(event, context);

    return fEventService.for(syllabusStore.getFeis().id).create(event).then(function (event) {
      return createSuccess(event, context);
    }).catch(function (err) {
      return createError(err, context);
    });
  }

  function remove(event, context) {
    removeStart(event, context);

    fEventService.for(syllabusStore.getFeis().id).delete(event.id).then(function () {
      return removeSuccess(event, context);
    }).catch(function (err) {
      return removeError(err, context);
    });
  }

  function update(event, context) {
    updateStart(event, context);

    return fEventService.for(syllabusStore.getFeis().id).update(event.id, event).then(function (event) {
      return updateSuccess(event, context);
    }).catch(function (err) {
      return updateError(err, context);
    });
  }

  function split(oldEvent, oldComps, newEvent, newComps, context) {
    splitStart(event, context);

    return fEventService.for(syllabusStore.getFeis().id).split(oldEvent.id, oldEvent, oldComps, newEvent, newComps).then(function (event) {
      return splitSuccess(event, context);
    }).catch(function (err) {
      return splitError(err, context);
    });
  }

  function merge(eventA, eventB, newEvent, context) {
    mergeStart(event, context);

    return fEventService.for(syllabusStore.getFeis().id).merge(eventA.id, eventB.id, newEvent).then(function (event) {
      return mergeSuccess(event, context);
    }).catch(function (err) {
      return mergeError(err, context);
    });
  }

  return {
    seed: seed,
    create: create,
    update: update,
    remove: remove,
    split: split,
    merge: merge
  };
});


//////////////////
// WEBPACK FOOTER
// ./syllabus/actions.js
// module id = 221
// module chunks = 0